import { createAction, props } from '@ngrx/store'
import { CategoriesEntity } from './categories.models'
import { Update } from '@ngrx/entity'
import { HttpErrorResponse } from '@angular/common/http'

export const loadCategories = createAction(
  '[Categories/API] Load Categories',
  props<{ searchTerm?: string; shouldReset?: boolean; limit?: number; offset?: number }>(),
)

export const setCategories = createAction(
  '[Categories/API] Set Categories',
  props<{ count: number; categories: CategoriesEntity[] }>(),
)

export const loadCategoriesSuccess = createAction(
  '[Categories/API] Load Categories Success',
  props<{ count: number; categories: CategoriesEntity[] }>(),
)

export const loadCategoriesFailure = createAction(
  '[Categories/API] Load Categories Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const selectCategory = createAction('[Categories/API] Select Category', props<{ uuid: string }>())
export const deleteCategory = createAction('[Categories/API] Delete Category', props<{ uuid: string }>())

export const updateCategoriesOrder = createAction(
  '[Categories/API] Update Categories Order',
  props<{ uuids: string[] }>(),
)

export const updateCategoriesSuccess = createAction(
  '[Categories/API] Update Categories Success',
  props<{ categories: Update<CategoriesEntity>[] }>(),
)

export const updateCategoriesFailure = createAction(
  '[Categories/API] Update Categories Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearSelectedCategory = createAction('[Categories/Page] Clear Selected Category')

export const deleteCategorySuccess = createAction('[Categories/API] Delete Category Success', props<{ uuid: string }>())

export const deleteCategoryFailure = createAction(
  '[Categories/API] Delete Category Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openCreateCategoryDialog = createAction('[Categories/Page] Open Create Category Dialog')

export const createCategory = createAction(
  '[Categories/API] Create Category',
  props<{
    label: string
    items?: string[]
    onSuccess?: (newCategory: CategoriesEntity) => void
  }>(),
)

export const createCategorySuccess = createAction(
  '[Categories/API] Create Category Success',
  props<{ category: CategoriesEntity }>(),
)

export const createCategoryFailure = createAction(
  'Categories/API] Create Category Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateCategory = createAction(
  '[Categories/API] Update Category',
  props<{ label: string; items: string[] }>(),
)
export const updateCategorySuccess = createAction(
  '[Categories/API] Update Category Success',
  props<{ category: Update<CategoriesEntity> }>(),
)

export const updateCategoryFailure = createAction(
  '[Categories/API] Update Category Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const displayGrid = createAction('[Categories/Page] Display Grid View')

export const displayTable = createAction('[Categories/Page] Display Table View')

export const clearCategories = createAction('[Categories/Page] Clear Categories')
